import GET_SPECIFIC_INTERVALS_FRAGMENT from '../graphql/getSpecificIntervals.fragment.graphql';
import { calculateEnabledDatesByIntervalsAvailability } from '../utils/deliveryIntervals.utils';

const maslenitsa = {
    date: '2025-03-02',
    enabled: true,
    id: '2025-03-02',
};

// maslenitsa

export const availableDatesField = {
    read(_, client) {
        const { cache, readField, variables } = client;

        const available = readField('available_dates') || [];

        const intervalsId = variables?.delivery_id ?? 'user-session';
        const currentIntervalsData = cache.readFragment({
            id: `intervals:${intervalsId}`,
            fragment: GET_SPECIFIC_INTERVALS_FRAGMENT,
        });

        const mappedDates = calculateEnabledDatesByIntervalsAvailability(available, currentIntervalsData);

        if (window.location.pathname.includes('maslenitsa')) {
            mappedDates.push(maslenitsa);
        }

        return mappedDates.filter((date) => {
            const { enabled } = date;
            return enabled;
        });
    },
};
